import * as yup from 'yup';

export const departmentSchema = yup.object({
  name: yup.string().required().min(1)
});
